import recommendedArticlesMap from "./constants/recommendationMaps";
import { Order } from "./constants/types";

export default function getRecommendedArticlesForOrder(order?: Order) {
  // Return if no order or order items available
  if (!order) return;

  // Get skus for items in order
  const skus = order.order_items.map((item) => item.sku);

  // Get articles for skus
  const articles = recommendedArticlesMap.products
    .filter((article) => article.skus.some((sku) => skus.includes(sku)))
    .map((el) => el.articles);

  // Flatten articles array
  const mergedArticlesArray = articles.flat();

  // Sort articles by weight
  const sortedArray = mergedArticlesArray.sort((a, b) => b.weight - a.weight);

  // Return articles is length is sufficient
  if (sortedArray.length >= 2) return sortedArray;

  // Get amount of general data sorted by weight
  const fillers = recommendedArticlesMap.general
    .sort((a, b) => b.weight - a.weight)
    .slice(0, 2 - sortedArray.length);

  // Return joined array
  return [...sortedArray, ...fillers];
}
